module.exports = __webpack_public_path__ + "img/folder.c75556ea.svg";